import axios from 'axios';
import { settings } from '@/api/config';
import { getInitData } from '@/utils/getInitData';
import { useProgressStore } from '@/store/ProgressStore';

export interface FlyerCpcResponse {
  tasks: FlyerCpcTask[];
}

export interface FlyerCpcTask {
  id: number;
  type: string;
  view_details: {
    title: string;
  };
  details: Record<string, any>;
  target_progress: number;
  user_progress: number;
  rewards: {
    stars: number;
  };
  status: 'active' | 'completed' | 'expired' | 'done' | 'claim';
}

// export const getFlyerCpcTasks = async (): Promise<FlyerCpcResponse> => {
//   if (!getInitData()) {
//     throw new Error('initData отсутствует');
//   }
//   const encodedInitData = encodeURIComponent(getInitData());
//   const url = `${settings.url}api/tasks/flyer-cpc/get?initData=${encodedInitData}`;
//   console.log('[FLYER_CPC] GET:', url);

//   try {
//     const response = await axios.get(url);
//     console.log('[FLYER_CPC] GET response:', response);
//     console.log('[FLYER_CPC] Response data:', response.data);
//     return response.data;
//   } catch (error) {
//     console.error('[FLYER_CPC] API error:', error);
//     throw error;
//   }
// };

export const claimFlyerCpcTask = async (taskId: number): Promise<void> => {
  if (!getInitData()) {
    throw new Error('initData отсутствует');
  }
  const encodedInitData = encodeURIComponent(getInitData());
  const url = `${settings.url}api/tasks/claim/${taskId}?initData=${encodedInitData}`;
  console.log('[FLYER_CPC] POST:', url);

  try {
    const response = await axios.post(url);
    console.log('[FLYER_CPC] POST response:', response);
    return response.data;
  } catch (error) {
    console.error('[FLYER_CPC] Claim error:', error);
    throw error;
  }
};

export const handleFlyerCpcCheckOnBack = async (banner_id: string) => {
  if (!getInitData()) {
    throw new Error('initData отсутствует');
  }
  const encodedInitData = encodeURIComponent(getInitData());
  const url = `${settings.url}api/banners/click/flyer/${banner_id}?initData=${encodedInitData}`;
  console.log('[FLYER_CPC] POST:', url);

  try {
    const response = await axios.post(url);
    return response.data;
  } catch (error) {
    console.error('[FLYER_CPC] Claim error:', error);
    throw error;
  }
};

// export const handleFlyerCpcClick = async () => {
//   if (!getInitData()) {
//     throw new Error('initData отсутствует');
//   }
//   const encodedInitData = encodeURIComponent(getInitData());
//   const url = `${settings.url}api/banners/flyer/click?initData=${encodedInitData}`;
//   try {
//     const response = await axios.post(url);
//     console.log('[FLYER_CPC] POST response:', response);
//     return response;
//   } catch (error) {
//     console.error('[FLYER_CPC] Claim error:', error);
//     throw error;
//   }
// };

export const getCPCBanner = async () => {
  if (!getInitData()) {
    throw new Error('initData отсутствует');
  }
  const encodedInitData = encodeURIComponent(getInitData());
  const url = `${settings.url}api/banners/get/flyer?initData=${encodedInitData}`;
  console.log('[FLYER_CPC] GET:', url);

  try {
    const response = await axios.get(url);
    console.log('[FLYER_CPC] GET response:', response);
    console.log('[FLYER_CPC] Response data:', response.data);
    return response.data;
  } catch (error) {
    console.error('[FLYER_CPC] API error:', error);
    throw error;
  }
};

export const postCPCBannerClick = async (taskId: string) => {
  if (!getInitData()) {
    throw new Error('initData отсутствует');
  }

  const initData = encodeURIComponent(getInitData());
  const url = `${settings.url}api/banners/flyer/click?initData=${initData}`;

  console.log('[FLYER_CPC] POST:', url);

  try {
    const response = await axios.post(url);
    await handleFlyerCpcCheckOnBack(taskId);
    console.log('[FLYER_CPC] POST response:', response);
    return response.data;
  } catch (error) {
    console.error('[FLYER_CPC] Claim error:', error);
    throw error;
  }
};
